import React from 'react';

import Link from 'gatsby-link';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: 178,
    height: 50,
    borderRadius: 125,
    backgroundColor: '#6a27e8',
    color: '#ffffff',
    fontFamily: 'Raleway',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 1.07,
    textAlign: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 130,
      fontSize: 12,
    },
    [theme.breakpoints.down('xs')]: {
      width: 160,
      fontSize: 14,
      marginBottom: 8,
    },
  },
});

const ReadMore = ({ classes, slug }) => (
  <Link to={`/blog/${slug}`} className={classes.root}>
    READ MORE
  </Link>
);

export default withStyles(styles)(ReadMore);
